import {Component} from '@angular/core';

/**
 * ░█▀▄░▀▀█░▀▀█░█▀█░█▀█░█▀█
 * ░█░█░░▀▄░░▀▄░█▀▀░█▀█░█░█
 * ░▀▀░░▀▀░░▀▀░░▀░░░▀░▀░▀░▀
 *
 * @author d33pan on 7/8/2026
 */
@Component({
  selector: 'app-form-card',
  imports: [],
  standalone: true,
  template: `
    <div class="mbank-card sections">
      <ng-content></ng-content>
    </div>
  `,
  styleUrl: './form-card.component.scss'
})
export class FormCardComponent {

}
